<template>
  <div style="width: 300px; height: 50%">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="contenedorTablaSinColor" style="height: 28vw !important;">
      <div class="d-flex align-items-center mt-4 ml-1 mr-1">
        <div class="contenedorTablaSinColor text-left" style="width: 21vw !important;">
          <b-input-group>
            <b-form-input
                class="input-filter"
                type="text"
                id="filterInput"
                :placeholder="placeholderBuscador"
                v-model="nombreBuscar"
                @keydown.enter.native="filtrarListaPorCoincidencia()"
            >
            </b-form-input>
            <b-col cols="2" lg="1" class="pl-0">
              <b-button
                  class="mt-1 "
                  size="sm"
                  variant="info"
                  :disabled="loading"
                  responsive
                  @click="filtrarListaPorCoincidencia()"
                  style="margin-left: -22px;"
              >
              <span v-if="!loading"
              >
                <em class="buscar_svg primary sm"></em>
              </span>
                <span v-else><b-spinner small></b-spinner></span>
              </b-button>
            </b-col>
          </b-input-group>
        </div>
        <div class="text-right ml-auto">
          <span v-if="blnFiltrarSeleccionados" @click="filtrarSeleccionados(false)">
            <em class="filtro_border_azul mr-2" style="height: 20px;"
                v-b-tooltip.hover.top="'FILTRAR SELECCIONADOS'"
                ></em>
          </span>
          <span v-else @click="filtrarSeleccionados(true)">
            <em class="fa fa-times" style="color: red; position: relative;left: 3px;top: -2px;"></em>
            <em class="filtro_border_azul mr-2" style="height: 20px;"
                v-b-tooltip.hover.top="'FILTRAR SELECCIONADOS'"
                ></em>
          </span>
          <b-form-checkbox size="sm" style="float: inline-end;" v-model="seleccionarTodos" @input="filtrarSeleccionadosTodos()"
                           v-b-tooltip.hover.top="'SELECCIONAR TODOS'"></b-form-checkbox>
        </div>

      </div>
      <div class="text-left ml-4 mr-1">
        <span class="ml-4" v-if="listaPrincipalAux.length > 0"><strong style="font-size: small">Nombre</strong></span>
        <div v-if="!loading && listaPrincipalAux.length === 0" class="text-center ml-1 mr-1 mt-2"
             style="font-weight: 600; font-size: 12px">
          <b-alert show variant="info" >Actualmente, no contamos con información.</b-alert>
        </div>
        <div v-show="!vistaAgrupador">
          <div class="mt-1" stacked style="overflow: auto; max-height: 41vh">
            <template v-for="(item) in listaPrincipalAux">

              <b-form-checkbox @change="buscar" :key="item.id"
                               v-model="item.seleccionado">
                {{ item.nombre }}
                <div class="borde"></div>
              </b-form-checkbox>
            </template>
          </div>
        </div>

        <div v-show="vistaAgrupador && opcionSeleccion == 1">
          <div class="mt-1" stacked style="overflow: auto; max-height: 41vh">
            <template v-for="(item) in listaPrincipalAux">

              <b-form-checkbox @change="buscar" :key="item.idTratamiento"
                               v-model="item.seleccionado">
                {{ item.nombreTratamiento }}
                <div class="borde"></div>
              </b-form-checkbox>
            </template>
          </div>
        </div>

        <div v-show="vistaAgrupador && opcionSeleccion == 2">
          <div class="mt-1" stacked style="overflow: auto; max-height: 41vh">
            <template v-for="(item) in listaPrincipalAux">

              <b-form-checkbox @change="buscar" :key="item.idCategoria"
                               v-model="item.seleccionado">
                {{ item.descripcion }}
                <div class="borde"></div>
              </b-form-checkbox>
            </template>
          </div>
        </div>

        <div v-show="vistaAgrupador && opcionSeleccion == 3">
          <div class="mt-1" stacked style="overflow: auto; max-height: 41vh">
            <template v-for="(item) in listaPrincipalAux">

              <b-form-checkbox @change="buscar" :key="item.id"
                               v-model="item.seleccionado">
                {{ item.nombre }}
                <div class="borde"></div>
              </b-form-checkbox>
            </template>
          </div>
        </div>


      </div>
      <div v-if="loading" class="d-flex justify-content-center align-items-center">
        <div class="your-div">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "listaFiltraComponente",
  props: {
    listaPrincipal: Array,
    placeholderBuscador: String,
    vistaAgrupador: Boolean,
    opcionSeleccion: Number,
    loaderEntrada:Boolean,
    selecionadoAutomatico:Boolean
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      loading: false,
      listaCheckeada: [],
      listaPrincipalAux: [],
      nombreBuscar: '',
      seleccionarTodos: false,
      blnFiltrarSeleccionados: true,
      listaNoCheckeada: [],
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.listaPrincipalAux = this.listaPrincipal.map(i => {i.seleccionado = false; return i});
  },
  computed: {
    selected() {
      return this.listaPrincipalAux.map(i => i.seleccionado)
    }
  },
  watch:{
    opcionSeleccion(){
      this.listaPrincipalAux = this.listaPrincipal;
    },
    "listaCheckeada":function(val){
      this.$emit('listaCheckeada', val)
    },
    "listaPrincipalAux": function () {
      this.buscar()
    },
    "nombreBuscar": async function () {
      if(this.nombreBuscar === ''){
        setTimeout(() => {
          this.filtrarListaPorCoincidencia();
        }, 500)
      }
    }
  },
  destroyed() {
    this.seleccionarTodos = false;
  },
  methods: {
    filtrarListaPorCoincidencia() {
      this.loading = true;
      this.listaPrincipalAux = [];
      if(this.opcionSeleccion == 1){
        setTimeout(() => {
          if (this.nombreBuscar !== null && this.nombreBuscar !== '') {
            this.listaPrincipalAux = this.listaPrincipal.filter(item => item.nombreTratamiento.toLowerCase().includes((this.nombreBuscar.toLowerCase())));
          } else {
            this.listaPrincipalAux = this.listaPrincipal;
          }
          this.loading = false;
        }, "1");
      } else if( this.opcionSeleccion == 2){
        setTimeout(() => {
          if (this.nombreBuscar !== null && this.nombreBuscar !== '') {
            this.listaPrincipalAux = this.listaPrincipal.filter(item => item.especialidad.toLowerCase().includes((this.nombreBuscar.toLowerCase())));
          } else {
            this.listaPrincipalAux = this.listaPrincipal;
          }
          this.loading = false;
        }, "1");
      }else {
        setTimeout(() => {
          if (this.nombreBuscar !== null && this.nombreBuscar !== '') {
            this.listaPrincipalAux = this.listaPrincipal.filter(item => item.nombre.toLowerCase().includes((this.nombreBuscar.toLowerCase())));
          } else {
            this.listaPrincipalAux = this.listaPrincipal;
          }
          this.loading = false;
        }, "1");
      }

    },
    filtrarSeleccionados(filtrar){
      this.blnFiltrarSeleccionados = filtrar;
      let listaSeleccionado = []
      if(!filtrar){
        this.listaPrincipalAux.forEach(i=>{
          if(i.seleccionado){
            listaSeleccionado.push(i);
          }
        })
        this.listaPrincipalAux = listaSeleccionado;
      }else{
      listaSeleccionado = this.listaPrincipalAux;
        this.listaPrincipalAux = [];
        this.listaPrincipal.forEach(item=> {
          let objetoDienteEncontrado = listaSeleccionado.find(objeto => objeto.id === item.id);
          if (objetoDienteEncontrado != null) {
            item.seleccionado = true
          }
          this.listaPrincipalAux.push(item)
        });
      }
    },
    filtrarSeleccionadosTodos(){
      this.listaPrincipalAux = this.listaPrincipalAux.map(i=> {i.seleccionado = this.seleccionarTodos ; return i});
    },
    buscar(){
      setTimeout(() => {
        const datos = this.listaPrincipalAux.filter(i => i.seleccionado)
        this.$emit('listaCheckeada', datos)
      }, 20);
    },
    noPerderNoSeleccionados(){
      console.log(this.listaPrincipalAux)
      console.log(this.listaNoCheckeada)
      this.listaNoCheckeada = this.listaPrincipalAux.filter(i => i.seleccionado === false);
    },
    agregarNoSeleccionados() {
      setTimeout(() => {
      let listaSeleccionado = [];
      this.listaPrincipalAux.forEach(i=>{
        let objetoDienteEncontrado = this.listaNoCheckeada.find(objeto => objeto.id === i.id);
        if(objetoDienteEncontrado != null){
          i.seleccionado = false;
        }
        listaSeleccionado.push(i);
      })
      this.listaPrincipalAux = listaSeleccionado;
      this.filtrarListaPorCoincidencia();
      }, 50)
    }
  }

}
</script>

<style scoped>
.borde {
  border-bottom: 1px solid #E6E6E6 !important;
  width: 19vw !important;
}
.contenedorTablaSinColor {
  border-color: #17A2B8;
  border-width: 1.5px !important;
}
</style>
